export function GradeBadge({ grade, score }: { grade: string | null; score?: number | null }) {
  if (!grade && score == null) return null;
  const tags = (grade || "").split(",").map((s) => s.trim()).filter(Boolean);
  return (
    <div className="flex flex-wrap gap-1.5 items-center">
      {tags.map((t) => (
        <span key={t} className="tag-grade">{t}</span>
      ))}
      {score != null ? (
        <span className="text-[10px] uppercase tracking-widest text-paper-500">
          Score · <span className="text-ink tabular-nums">{score.toFixed(2)}</span>
        </span>
      ) : null}
    </div>
  );
}
